import { Search } from '@humaninterest/hi-react-dripicons';

export const searchInputStandard = {
  placeholder: 'Search Learning Center',
  width: 'auto',
  LeftIcon: Search,
  bg: 'white',
  minWidth: '240px',
};
